import { Form, Field, FormElement, FieldWrapper, FieldRenderProps, FormRenderProps } from '@progress/kendo-react-form';
import { Label, Error, Hint, FloatingLabel } from '@progress/kendo-react-labels';
import { Input,Checkbox,CheckboxChangeEvent } from '@progress/kendo-react-inputs';
import { DropDownList,DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faInfoCircle,faL,faQuestionCircle} from '@fortawesome/free-solid-svg-icons';
import { SubmitUploadFiles } from './InfoBoxes';
import {Upload, UploadFileInfo, UploadOnAddEvent, UploadOnRemoveEvent} from '@progress/kendo-react-upload';
import { docLinks } from './Configuration';
import { DocLinks } from '../services/interfaces';
import { Button } from 'reactstrap';
import { UserContext } from './UserContext';
import { SubmissionContext } from './SubmissionFormContext';
import { useContext,useState,useEffect, useRef } from 'react';
import { PageContext } from './PageContext';
import { fileTypes } from './Configuration';
import { FileType } from '../services/interfaces';
import { Grid, GridColumn } from '@progress/kendo-react-grid';

import React from 'react';

interface FileTypeListProps {
    typelist: FileType[];
    setTypes: (types: FileType[]) => void;
}

const FileTypeList: React.FC<FileTypeListProps> = ({ typelist, setTypes }) => {
    const subContext = useContext(SubmissionContext);

    useEffect(() => {
        fileTypes().then(data => {
            if (subContext?.submitForm.adType.value=="RM"){
                var zipType:FileType={
                    type:"ART",
                    extension:".zip",
                    description:"ZIP Archive"
                }
                data.types.push(zipType);
            }
            setTypes(data.types);
        });
    }, [setTypes]);

    return (
        <Grid
            data={typelist}
            style={{ height: 200 }}
        >
            <GridColumn field='type' title='Type' />
            <GridColumn field='extension' title='Extension' />
            <GridColumn field='description' title='Description' />
        </Grid>
    );
};

function FileForm(){
    const subContext = useContext(SubmissionContext);
    const pageContext=useContext(PageContext);
    const pressReady = pageContext?.uiFeatures.pressReady;
    const simplePR = pageContext?.uiFeatures.simplePressReady;

    const [showFSConfirm,setShowFSConfirm]=useState(false);
    const [types, setTypes] = useState<FileType[]>([]);
    const [typeLimit,setTypeLimit]=useState<string[]>([]);
    
    function changeNoFiles(check:CheckboxChangeEvent){
        subContext?.setSubmitForm(prevObject=>({...prevObject,noFiles:check.value}));
    }

    function changeMultiPage(check:CheckboxChangeEvent){
        subContext?.setSubmitForm(prevObject=>({...prevObject,multiPage:check.value}));
    }

    function changePR(check:CheckboxChangeEvent){
        subContext?.setSubmitForm(prevObject=>({...prevObject,prCheck:check.value}));
        if (check.value==true){
            if (!simplePR){
                setShowFSConfirm(true)
            }else{
                setAllFilesIn(true);
                setPRConfirm();
            }

        }else{
            setShowFSConfirm(false);
        }
    }

    const setAllFilesIn=(setVal:boolean)=>{
        subContext?.setSubmitForm(prevObject=>({...prevObject,allFilesIn:setVal}));
    }
     const setPRConfirm=()=>{
        subContext?.setSubmitForm(prevObject=>({...prevObject,prConfirm:{value:"YES", label:"No changes needed. Ad is approved"}}));
    }

    function changeAllIn(check:CheckboxChangeEvent){
        subContext?.setSubmitForm(prevObject=>({...prevObject,allFilesIn:check.value}));
    }

    function changeCopyCampaign(check:CheckboxChangeEvent){
        subContext?.setSubmitForm(prevObject=>({...prevObject,copyCampaign:check.value}));
    }

    function changeFSConfirm(selection:DropDownListChangeEvent){
        subContext?.setSubmitForm(prevObject=>({...prevObject,prConfirm:selection.value}));
    }

    const uploadRef = useRef<Upload>(null);

    const saveFileState=(files:Array<UploadFileInfo>)=>{
        subContext?.setFiles(files);
    }

    function removeFile(event:UploadOnRemoveEvent){
        saveFileState(event.newState);
    }
    function addFile(event:UploadOnAddEvent){
        saveFileState(event.newState);
        event.affectedFiles.forEach(file=>{
            console.log(event);
            const elType = types.find((fileinfo)=>fileinfo.extension===file.extension);
            //console.log(elType);
            if (file.extension!=undefined && file.size!=undefined && elType?.type!=undefined){
                subContext?.submitForm.fileList.push({type:elType?.type,fileName:file.name,size:file.size,extension:file.extension,status:""});
            }
        })
        console.log(subContext?.submitForm.fileList);
    }

    useEffect(()=>{
        const limitTypes:string[] = []; 
        types.forEach(type=>{
            limitTypes.push(type.extension);
        })
        setTypeLimit(limitTypes);
    },[types])

   
    return(
        <>
            <Checkbox onChange={changeNoFiles} checked={subContext?.submitForm.noFiles}label='I am not submitting files at this time.'/>
            {pageContext?.glSettings.HideMoreFilesToCome?null:<Checkbox onChange={changeAllIn} checked={subContext?.submitForm.allFilesIn}label='More files to come. This ad is NOT ready for production'/>}
            {pressReady?<Checkbox onChange={changePR} checked={subContext?.submitForm.prCheck} label='This order includes a fully-designed or press ready ad.'/>:null}            
            <span className='d-none'><Checkbox onChange={changeCopyCampaign} checked={subContext?.submitForm.copyCampaign} label='Copy to all ads in the campaign'/></span>
            {subContext?.submitForm.adType.value==="DA"?<Checkbox onChange={changeMultiPage} checked={subContext?.submitForm.multiPage} label='This is a multi-page ad.'/>:null}
            {showFSConfirm?
                <FieldWrapper>
                    <Label className='mb-3'>Does the submitted ad require changes:</Label>
                    <DropDownList
                        data={[
                            {value:"YES", label:"No changes needed. Ad is approved"},
                            {value:"NO", label:"Stretch or squeeze to fit"},
                            {value:"NO", label:"Add a border"},
                            {value:"NO", label:"Add text (include on instructions tab)"},
                            {value:"NO", label:"Special instructions (include on instructions tab"}
                        ]}
                        onChange={changeFSConfirm}
                        textField='label'
                        dataItemKey='value'
                    />
                </FieldWrapper> 
            :null}
            <div className='mb-3 mt-3'>
                <SubmitUploadFiles/>
            </div>
            <FieldWrapper>
                <Upload
                    ref={uploadRef}
                    files={subContext?.files}
                    autoUpload={false}
                    onAdd={addFile}
                    onRemove={removeFile}
                    withCredentials={false}
                    saveUrl={"/api/TestUpload"}
                    restrictions={{allowedExtensions: typeLimit, maxFileSize:parseInt(pageContext?.glSettings.MaxUploadsize ?? '100000')}}
                />
                <Label className='mb-3 mt-3'><strong>The following file types are allowed:</strong></Label>
                <FileTypeList typelist={types} setTypes={setTypes}/>
            </FieldWrapper>
        </>
    )
}


export const SubmitFile=(
    <div>
        <h5>UPLOAD FILES:</h5>
        <FileForm/>
    </div>
)

